import {
	BaseRegisteredExtension,
	ExtensionContextType,
	ExtensionManifest,
	ExtensionPermissions,
	ExtentionPriority,
	IRegisteredExtension,
	DEFAULT_MODULE_IDS,
	SearchState,
	IDynamicValue,
	ISearchNodeImplementationModule
} from '@elyx-code/project-logic-tree';
import { browserSearchImplementation } from '../../../local-relational-database';
import { EditorService } from '../../EditorService';

export class SearchNodeImplementationModule
	extends BaseRegisteredExtension
	implements IRegisteredExtension<ISearchNodeImplementationModule>
{
	manifest: ExtensionManifest = {
		id: DEFAULT_MODULE_IDS.SEARCH_NODE_IMPLEMENTATION,
		version: '1.0.0',
		description:
			'Implementation for search nodes when they get executed and query data.',
		initPriority: ExtentionPriority.High,
		permissions: [ExtensionPermissions.All],
		contexts: [ExtensionContextType.Editor, ExtensionContextType.Logic]
	};

	module = {
		main: (entity: SearchState, inputs: IDynamicValue[]) => {
			const project = this.extensionsRegistry.requestContexts(this, [
				ExtensionContextType.Editor
			])?.[0] as EditorService;

			return browserSearchImplementation(entity, inputs, project);
		}
	};
}
